var map = {
	"./network-logos/aptos-disable.svg": 695,
	"./network-logos/aptos.svg": 492,
	"./network-logos/arbitrum-disable.svg": 696,
	"./network-logos/arbitrum.svg": 697,
	"./network-logos/avax-disable.svg": 698,
	"./network-logos/avax.svg": 699,
	"./network-logos/base-disable.svg": 700,
	"./network-logos/base.svg": 701,
	"./network-logos/bsc-disable.svg": 702,
	"./network-logos/bsc.svg": 703,
	"./network-logos/cronos-disable.svg": 704,
	"./network-logos/cronos.svg": 705,
	"./network-logos/ethereum-disable.svg": 706,
	"./network-logos/ethereum.svg": 707,
	"./network-logos/fantom-disable.svg": 708,
	"./network-logos/fantom.svg": 709,
	"./network-logos/optimism-disable.svg": 710,
	"./network-logos/optimism.svg": 711,
	"./network-logos/phantom.svg": 712,
	"./network-logos/polygon-disable.svg": 713,
	"./network-logos/polygon.svg": 714,
	"./network-logos/solana-disable.svg": 715,
	"./network-logos/solana.svg": 716,
	"./network-logos/sui-disable.png": 717,
	"./network-logos/sui.png": 718
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1343;